import Input from "@/components/input";
import axios from "@/axios";
import loader from "@/components/loader";
import Button from "@/components/button";


export default {
    name: "create-package",
    components: {
        "neo-input":Input,
        "neo-button":Button,
        axios,
        loader,
    },
    mounted(){
        
    }, 

    data() {
        return {
            packageCreationInProgress:false,
            package:{
                package_name:'',
                package_name_internal:'',
                package_description:''
            }
        };
    },
    methods: {
        async createPackage(){
            
            try{
                let url = `/screening-package`;
                this.packageCreationInProgress = true
                await axios.post(url, this.package);
                this.$toast.success("Package created");
                this.$router.push(
                    {
                        "name":"Screening Package"
                    }
                )
            }
            catch(error){
                this.$toast.warning("Could not create package!");
            }

            this.packageCreationInProgress = false
        }
    },
};


